export {default as StarterpacksPage} from './StarterpacksPage';



// WEBPACK FOOTER //
// ./src/pages/StarterpacksPage/index.ts